import { pickBy, isNaN } from 'lodash';

export const DEFAULT_QUEUE_INTERVAL = 5000;

export const tableMonth = [
  {
    key: '01',
    label: 'January',
  },
  {
    key: '02',
    label: 'February',
  },
  {
    key: '03',
    label: 'March',
  },
  {
    key: '04',
    label: 'April',
  },
  {
    key: '05',
    label: 'May',
  },
  {
    key: '06',
    label: 'June',
  },
  {
    key: '07',
    label: 'July',
  },
  {
    key: '08',
    label: 'August',
  },
  {
    key: '09',
    label: 'September',
  },
  {
    key: '10',
    label: 'October',
  },
  {
    key: '11',
    label: 'November',
  },
  {
    key: '12',
    label: 'December',
  },
];

export const setInitPageFilters = (pageCode, query) => {
  switch (pageCode) {
  case 'orders':
  case 'payments':
    return pickBy({
      mode: query?.mode,
      year: query?.year,
    });

  case 'profits':
    return pickBy({
      year: query?.year,
    });

  case 'tickets':
    return pickBy({
      mode: query?.mode,
      year: query?.year,
      staff: query?.staff,
    });

  default:
    return query;
  }
};

export const checkInterval = (value) => {
  if (value !== null && value >= 0 && !isNaN(value)) {
    return value * 1000;
  }
  return DEFAULT_QUEUE_INTERVAL;
};
